var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"appContent"},[_c('h1',{staticClass:"appContent__title"},[_vm._v(_vm._s(_vm.$t('pageNames.' + _vm.$route.name)))]),_c('app-header-card'),_c('div',{staticClass:"appContent__content"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }